export class IntervalHelper {
    private intervalMap = new Map<string, number>();
  
    startInterval(key: string, cb: () => void, ms: number) {
      this.stopInterval(key); // clear trước nếu đã tồn tại
      const id = window.setInterval(cb, ms);
      this.intervalMap.set(key, id);
    }
  
    stopInterval(key: string) {
      const id = this.intervalMap.get(key);
      if (id !== undefined) {
        clearInterval(id);
        this.intervalMap.delete(key);
      }
    }
  
    stopAllIntervals() {
      for (const id of this.intervalMap.values()) {
        clearInterval(id);
      }
      this.intervalMap.clear();
    }
  
    isRunning(key: string): boolean {
      return this.intervalMap.has(key);
    }
  }
  